import React, { Component } from 'react';
import { Row, Col, InputGroup, InputGroupAddon, Input, Card, CardBody } from 'reactstrap';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import swal from 'sweetalert';
import { Redirect } from '../../../utils/router-compat';
import FleetVehicleDetails from './FleetVehicleDetails';
import './FleetDetail.css';
import FleetTypeFilter from './FleetTypeFIlter';
import FleetService from '../../../services/FleetService';
import ModalService from '../../../services/ModalService';
import CustomSpinner from '../../CustomSpinner/CustomSpinner';
import { downlodFile } from '../../../utils/utils';
import lodash from "lodash"; // library added for debounce functionality
import MappleToolTip from "reactjs-mappletooltip";
import Storage from "../../../services/Storage";
import { Permissions } from '../../../constants/constant.permissions';
import { Roles } from '../../../constants/constant.role';

class ListOfFleets extends Component {

  constructor(props) {
    super(props);
    this.state = {
      userDetail: Storage.getUserDetail(),
      controls: {
        fleetSearchBox: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
          invalidFirstname: null
        }
      },
      // type: 'true',
      fleetDetailFilterData: Object.assign({}),
      headers: {},
      fleet_detail_list: [],
      isLoadingList: false,
      isLoadingCard: false,
      pageCount: 0,
      total_fleets: 0,
      page: 1,
      fleetDetailCard: {
        "member_prospect_fleet": {
          "member": 0,
          "prospect": 0
        },
        "direct_indirect_fleet": {
          "direct": 0,
          "indirect": 0,
          "mobility": 0
        },
        "status_fleet": {
          "active": 0,
          "inactive": 0,
          "month": 0
        },
        "vehicles": {
          "truck": 0,
          "bus": 0,
          "others": 0
        },
        "fleet_potential": {
          "tbb": 0,
          "tbr": 0
        },
        "member_fleet_potential": {
          "radialization": 0,
          "total_tubless_tyre": 0,
          "retread_potential": 0
        }
      },
      redirectToProfile: false,
      fleetId: '',
      type: ''
    };
    this.searchFleet = lodash.debounce(this.searchFleet, 500);
  }

  componentDidMount() {
    this.getFleetDetailCard();
    this.getFleetDetail();

    let type = Storage.getUserDetail().type;
    this.setState({
      type: type
    }, () => { })
  }

  getFleetDetail = async (download_report = false, is_handle_page_change = false) => {
    try {
      let { fleet_detail_list, headers, fleetDetailFilterData, pageCount, page, total_fleets, controls,
        isLoadingList,
      } = this.state;
      let reqData = {};
      if (fleetDetailFilterData && Object.keys(fleetDetailFilterData).length > 0) {
        if (fleetDetailFilterData.member_type) {
          reqData.member_type = fleetDetailFilterData.member_type;
        }
        if (fleetDetailFilterData.fleet_type) {
          reqData.fleet_type = fleetDetailFilterData.fleet_type;
        }
        if (fleetDetailFilterData.fleet_status) {
          reqData.fleet_status = fleetDetailFilterData.fleet_status;
        }
        if (fleetDetailFilterData.is_all_fleets) {
          reqData.is_all_fleets = true;
        }
        if (fleetDetailFilterData.club_name) {
          reqData.club_name = fleetDetailFilterData.club_name;
        }
      } else {
        reqData.is_all_fleets = false;
        reqData.member_type = "member";
        reqData.fleet_status = "active";
        // reqData.club_name = "";
      }
      if (controls.fleetSearchBox.value) {
        reqData.q = controls.fleetSearchBox.value;
      }
      if (download_report) {
        reqData.download_report = download_report;
      }
      if (is_handle_page_change) {
        reqData.page = page;
        reqData.pagesize = 10;
      } else {
        page = 1;
        reqData.page = page;
        reqData.pagesize = 10;
      }
      this.setState({
        isLoadingList: true
      })
      let { data } = await FleetService.getFleetDetailData(reqData);
      isLoadingList = false;
      this.setState({
        isLoadingList
      })
      if (download_report) {
        const { file } = data.data;
        downlodFile(file);
      } else {
        if (data) {

          headers = data.data.header;
          fleet_detail_list = data.data.user_details;
          pageCount = Math.trunc(data.data.total_count / 10) + 1;
          total_fleets = data.data.total_count;

        } else {
          headers = {};
          fleet_detail_list = [];
          pageCount = 0;
          page = 1;
          total_fleets = 0;
        }
      }
      this.setState(prevState => ({
        ...prevState,
        isLoadingList,
        headers,
        fleet_detail_list,
        pageCount, page,
        total_fleets
      }));
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert('', e.response.data.error[0].message, 'error');
      }
      this.setState({
        isLoadingList: false
      });
      console.log('err', e);
    }
  }


  getFleetDetailCard = async () => {
    try {
      let { fleetDetailCard } = this.state;
      this.setState({
        isLoadingCard: true
      })
      const { data } = await FleetService.getFleetDetailCard();
      if (data) {
        fleetDetailCard = data.data;
      }
      this.setState({
        fleetDetailCard,
        isLoadingCard: false
      })
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert('', e.response.data.error[0].message, 'error');
      }
      this.setState({
        isLoadingCard: false
      });
      console.log('err', e);
    }
  }

  searchFleet = (e) => {
    this.getFleetDetail(false)
  }

  handleSearchChange = e => {
    const { controls } = this.state;
    controls['fleetSearchBox'].touched = true;
    controls['fleetSearchBox'].value = e.target.value;
    this.setState({
      controls
    }, () => {
      this.searchFleet();
    })
  };

  fleetNameClick = (fleetId) => {
    /*const wrapper = document.createElement('div');
    ReactDOM.render(<Profile fleetId={fleetId} />, wrapper);
    const el = wrapper.firstChild;
    swal({
      text: '',
      content: el,
      buttons: false,
      className: 'fleet-detail-profile',
      closeOnClickOutside: false,
      closeOEscapeKey: false,
      closeOnConfirm: false
    }).then(value => {
    }); */
    this.setState({
      redirectToProfile: true,
      fleetId: fleetId
    }, () => { })
  }

  fleetTotalTyreClick = (item, tyres) => {
    if (tyres === 0 || tyres === '0') {
      return;
    }
    const wrapper = document.createElement('div');
    ReactDOM.render(<FleetVehicleDetails fleet={item} />, wrapper);
    const el = wrapper.firstChild;
    swal({
      text: '',
      content: el,
      buttons: false,
      className: 'fleet-vehicle-details',
      closeOnClickOutside: false,
      closeOEscapeKey: false,
      closeOnConfirm: false
    }).then(value => {
    });
  }
  handlePageClick = (e) => {
    this.setState({
      page: e.selected + 1
    }, () => {
      this.getFleetDetail(false, true);
    })
  };

  handleFleetChange = (e) => {
    const { controls } = this.state;
    const { fleetSearchBox } = controls;
    let type = e.target.value;
    this.setState({ type });
    let isActive = null;
    if (type === 'all') {
      isActive = null
    } else if (type === 'true') {
      isActive = true
    } else if (type === 'false') {
      isActive = false
    }
    this.props.getFleetsTotalVehiclesAndTyres({ query: fleetSearchBox.value, page: 1, pagesize: 10, isActive });
  }

  downloadExcelFleet = async () => {
    this.getFleetDetail(true, false);
  }

  downloadExcel = async () => {
    //this.getFleetDetail(true);
    try {
      let download_report = true;
      let { fleet_detail_list, headers, fleetDetailFilterData, pageCount, page, total_fleets, controls,
        isLoadingList,
      } = this.state;
      let reqData = {};
      if (fleetDetailFilterData && Object.keys(fleetDetailFilterData).length > 0) {
        if (fleetDetailFilterData.member_type) {
          reqData.member_type = fleetDetailFilterData.member_type;
        }
        if (fleetDetailFilterData.fleet_type) {
          reqData.fleet_type = fleetDetailFilterData.fleet_type;
        }
        if (fleetDetailFilterData.fleet_status) {
          reqData.fleet_status = fleetDetailFilterData.fleet_status;
        }
        if (fleetDetailFilterData.is_all_fleets) {
          reqData.is_all_fleets = true;
        }
      } else {
        reqData.is_all_fleets = true;
      }
      if (controls.fleetSearchBox.value) {
        reqData.q = controls.fleetSearchBox.value;
      }
      if (download_report) {
        reqData.download_report = download_report;
      }

      this.setState({
        isLoadingList: true
      })
      let { data } = await FleetService.downloadfleetreport(reqData);
      isLoadingList = false;
      this.setState({
        isLoadingList
      })
      if (download_report) {
        const { file } = data.data;
        downlodFile(file);
      } else {
        if (data) {
          headers = data.data.header;
          fleet_detail_list = data.data.user_details;
          pageCount = Math.trunc(data.data.total_count / 10) + 1;
          total_fleets = data.data.total_count;
        } else {
          headers = {};
          fleet_detail_list = [];
          pageCount = 0;
          page = 1;
          total_fleets = 0;
        }
      }
      this.setState(prevState => ({
        ...prevState,
        isLoadingList,
        headers,
        fleet_detail_list,
        pageCount, page,
        total_fleets
      }));
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert('', e.response.data.error[0].message, 'error');
      }
      this.setState({
        isLoadingList: false
      });
      console.log('err', e);
    }
  }

  applyFilter = (controls) => {
    let { fleetDetailFilterData } = this.state;
    fleetDetailFilterData = lodash.cloneDeep(controls);
    this.setState(prevState => ({
      ...prevState,
      fleetDetailFilterData
    }), () => {
      this.getFleetDetail();
    })
  }

  render() {
    const { controls,
      // type, 
      redirectToProfile, fleetId } = this.state;
    const { fleetSearchBox } = controls;
    let { fleetDetailCard, fleet_detail_list, headers, isLoadingList, total_fleets, fleetDetailFilterData } = this.state;
    let { userDetail } = this.state;

    // const mappleConfig = {
    //   direction: "bottom",
    //   backgroundColor: "white",
    //   float: false
    // };
    return (
      <div id="list-fleet">
        {redirectToProfile && (
          <Redirect
            to={{
              pathname: "/profile",
              search: `fleetId=${fleetId}`
            }}
          />
        )}

        <div style={{ position: 'relative' }}>
          {/* {this.state.isLoadingCard && <CustomSpinner marginTop="0%" />} */}
          <Row>
            <Col className="offtake-title">
              Fleet Details

              {/* <Input type="radio">Non Member</Input> */}
            </Col>
          </Row>
          {/* <Row> */}
          {/* <Col xl="4" className="mt-3 pl-2 pr-2">
              <Card className="height-100 fleet-card-detail-count">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px' }}>
                  <Row className="width-100">
                    <Col xl="12" md="12" xs="12" className="pb-2">
                      <span className="fleet-detail-carde-title">Total Fleets</span>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12">

                          <div className="fleet-detail-card-title-image">
                          </div>
                        </Col>
                        <Col xl="8" md="12" xs="12">
                          <Row>
                            <Col xl="6" md="12" xs="12" className="d-flex-column" style={{ borderRight: 'solid 1.2px #ffffff' }}>
                              <span className="fleet-detail-card-sub-title">JK Fleets</span>
                              <span className="fleet-detail-card-sub-title-count">
                                {fleetDetailCard.member_prospect_fleet.member}
                              </span>
                            </Col>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <span className="fleet-detail-card-sub-title ml-3">
                                Prospect
                              </span>
                              <span className="fleet-detail-card-sub-title-count ml-3">
                                {fleetDetailCard.member_prospect_fleet.prospect}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col> */}
          {/* hide changes 8aug23 */}
          {/* <Col xl="4" className="mt-3 pl-2 pr-2">
              <Card className="height-100 fleet-card-detail-count">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px' }}>
                  <Row className="width-100">
                    <Col xl="12" md="12" xs="12" className="pb-3">
                      <span className="fleet-detail-carde-title">JK Fleets</span>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column">
                          <span className="fleet-detail-card-sub-title">Direct</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                            {fleetDetailCard.direct_indirect_fleet.direct}
                          </span>
                        </Col>
                        <Col xl="8" md="12" xs="12">
                          <Row>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <span className="fleet-detail-card-sub-title">Indirect</span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.direct_indirect_fleet.indirect}
                              </span>
                            </Col>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <span className="fleet-detail-card-sub-title">
                                Mobility
                              </span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.direct_indirect_fleet.mobility}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col> */}
          {/* <Col xl="4" className="mt-3 pl-2 pr-2">
              <Card className="height-100 fleet-card-detail-count">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px' }}>
                  <Row className="width-100">
                    <Col xl="12" md="12" xs="12" className="pb-3">
                      <span className="fleet-detail-carde-title">JK Fleet Status</span>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column">
                          <span className="fleet-detail-card-sub-title">Month</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                            {fleetDetailCard.status_fleet.month}
                          </span>
                        </Col>
                        <Col xl="8" md="12" xs="12">
                          <Row>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <span className="fleet-detail-card-sub-title">Active</span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.status_fleet.active}
                              </span>
                            </Col>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <span className="fleet-detail-card-sub-title">
                                In-active
                              </span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.status_fleet.inactive}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl="4" className="mt-3 pl-2 pr-2">
              <Card className="height-100 fleet-card-detail-count">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px', paddingRight: '0' }}>
                  <Row className="width-100">
                    <Col xl="12" md="12" xs="12" className="pb-3">
                      <span className="fleet-detail-carde-title">Vehicle Strength of JK Fleet</span>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column pr-0">
                          <span className="Truck-lbl">Truck</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                            {fleetDetailCard.vehicles.truck}
                          </span>
                        </Col>
                        <Col xl="8" md="12" xs="12" className="pl-0 pr-0">
                          <Row className="pl-0 pr-0">
                            <Col xl="4" md="12" xs="12" className="d-flex-column p-0">
                              <span className='Truck-lbl'>Bus</span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.vehicles.bus}
                              </span>
                            </Col>
                            <Col xl="8" md="12" xs="12" className="d-flex-column p-0">
                              <span className="Truck-lbl">
                                Others <span style={{ fontSize: '13px', fontWeight: 'normal' }}>(LCV/SCV/ICV/Pickup)</span>
                              </span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.vehicles.others}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col> */}
          {/* hide changes 8aug23 */}
          {/* <Col xl="4" className="mt-3 pl-2 pr-2">
              <Card className="height-100 fleet-card-detail-count">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px' }}>
                  <Row className="width-100">
                    <Col xl="12" md="12" xs="12" className="pb-3 d-flex-row">
                      <span className="fleet-detail-carde-title">JK Fleet Potential (Avg / Month) </span>
                      <MappleToolTip float={true} direction={'left'}
                        backgroundColor="#ffffff">
                        <div style={{ marginLeft: '10px' }}>
                          <img
                            src="images/about-545a60.svg"
                            alt='about-545a60'
                            id="editorimage"
                            style={{ cursor: 'pointer' }}
                            onClick={this.Show_entermsgcontent}
                          />
                        </div>
                        <div style={{ width: '500px' }}>
                          <div className="pl-0 mt-1">
                            <span className="fleet-detail-tooltip-value d-flex-column">
                              <span className="fleet-detail-tooltip-value font-weight-bold">Below are the calculation Formulas :</span>
                              <ol type="1" className="pl-0 mt-1">
                                <li className="fleet-detail-tooltip-value d-flex-column">
                                  <span className="font-weight-bold">1.&nbsp;TBR  Potential (Avg / Month):</span>
                                  <span style={{ marginTop: '5px' }}>(Total Yearly TBR of all JK Fleets) / 12</span>
                                </li>
                                <li className="fleet-detail-tooltip-value d-flex-column mt-2"><span className="font-weight-bold">2.&nbsp; TBB  Potential (Avg / Month):</span>
                                  <span style={{ marginTop: '5px' }}>(Total Yearly TBB of all JK Fleets) / 12</span>
                                </li>
                                <li className="fleet-detail-tooltip-value d-flex-column mt-2"><span className="font-weight-bold">3.&nbsp; Retread Potential (Avg / Month):</span>
                                  <span style={{ marginTop: '5px' }}>We first calculate Retread % is a weighted average calculated as below</span>
                                  <span style={{
                                    marginTop: '5px'
                                  }}
                                    dangerouslySetInnerHTML={{
                                      __html: `<span>
                                            {[(Total Bus Vehicles of a fleet1)*(Retread % of Bus for fleet1)] + [(Total Truck Vehicles of a fleet1)*(Retread % of Truck for fleet1)]+...+[(Total Bus Vehicles of a fleetn)*(Retread % of Bus for fleet N)] + [(Total Truck Vehicles of a fleet N)*(Retread % of Truck for fleet N)]} * 100 / [Total Number of Vehicles]
                                            </span>`}}>
                                  </span>
                                  <span style={{
                                    marginTop: '8px'
                                  }}>
                                    Now based on Retread % we calculate Retread Potential ) as below
                                  </span>
                                  <span style={{
                                    marginTop: '1px'
                                  }}>
                                    (Total Tyre Potential of JK Fleet) * (Retread %)
                                  </span>
                                </li>
                              </ol>


                              <span>- Find Weighted Average of Retread %</span>
                              <span>- Multiply Total Tyre Potential (TBR+TBB) with Retread % and that will be Retread &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Potential.</span>
                            </span>
                          </div>

                        </div>
                      </MappleToolTip>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column">
                          <span className="Truck-lbl">TBR</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                            {fleetDetailCard.fleet_potential.tbr}
                          </span>
                        </Col>
                        <Col xl="8" md="12" xs="12">
                          <Row>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <span className="Truck-lbl">TBB</span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.fleet_potential.tbb}
                              </span>
                            </Col>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <div className="d-flex-row">
                                <span className="Truck-lbl">
                                  Retread
                                </span>
                              </div>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.member_fleet_potential.retread_potential ?
                                  Math.round(fleetDetailCard.member_fleet_potential.retread_potential) + '' : 0}
                              </span>
                            </Col>
                            <Col xl="6" md="12" xs="12" className="d-flex">
                              <span className="fleet-detail-avg-month-lbl" style={{ marginTop: 'auto', marginBottom: '6px' }}>Avg / Month</span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col xl="4" className="mt-3 pl-2 pr-2">
              <Card className="height-100 fleet-card-detail-count">
                <CardBody className="report-dashboard-card-center" style={{ padding: '15px' }}>
                  <Row className="width-100">
                    <Col xl="12" md="12" xs="12" className="pb-3">
                      <span className="fleet-detail-carde-title d-flex-row">
                        <span>JK Fleet Potential Distribution</span>
                        <MappleToolTip float={true} direction={'left'}
                          backgroundColor="#ffffff">
                          <div style={{ marginLeft: '10px' }}>
                            <img
                              src="images/about-545a60.svg"
                              id="editorimage"
                              alt='about-545a60'
                              style={{ cursor: 'pointer' }}
                              onClick={this.Show_entermsgcontent}
                            />
                          </div>
                          <div style={{ width: '500px' }}>
                            <span className="fleet-detail-tooltip-value font-weight-bold">Below are the calculation Formulas :</span>
                            <ol type="1" className="pl-0 mt-1">
                              <li className="fleet-detail-tooltip-value d-flex-column"><span className="font-weight-bold">1.&nbsp;Radialization %:</span>
                                <span style={{ marginTop: '5px' }}>(Total TBR of all Fleets) * 100/ (Total TBR  of all fleets + Total TBB of all fleets)</span>
                              </li>
                              <li className="fleet-detail-tooltip-value d-flex-column mt-2"><span className="font-weight-bold">2.&nbsp;Tubeless %:</span>
                                <span style={{ marginTop: '5px' }}>(Total Tubeless of all Fleets)*100 / (Total Tubeless Tyres of all fleets + Total Tube Tyre of all fleets)</span>
                              </li>

                            </ol>
                          </div>
                        </MappleToolTip>

                      </span>
                    </Col>
                    <Col xs="12">
                      <Row>
                        <Col xl="4" md="12" xs="12" className="d-flex-column">
                          <span className="Truck-lbl">Radialization</span>
                          <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                            {fleetDetailCard.member_fleet_potential.radialization ?
                              Math.round(fleetDetailCard.member_fleet_potential.radialization) + '%' : 0}
                          </span>
                        </Col>
                        <Col xl="8" md="12" xs="12">
                          <Row>
                            <Col xl="6" md="12" xs="12" className="d-flex-column">
                              <span className="Truck-lbl">Tubeless</span>
                              <span className="fleet-detail-card-sub-title-count" style={{ fontSize: '22px' }}>
                                {fleetDetailCard.member_fleet_potential.total_tubless_tyre ?
                                  Math.round(fleetDetailCard.member_fleet_potential.total_tubless_tyre) + '%' : 0}
                              </span>
                            </Col>

                          </Row>
                        </Col>
                      </Row>
                    </Col>

                  </Row>
                </CardBody>
              </Card>
            </Col> */}
          {/* </Row> */}
        </div>

        <br />
        <div className="d-flex-column" style={{ position: 'relative' }}>
          {isLoadingList && <CustomSpinner marginTop="0%" />}
          <Row style={{ marginTop: '5px' }}>
            <Col xl="4" md="4" sm="12" xs="12">
              <InputGroup className="social-detail-date">
                <Input
                  type="text"
                  name="fleetSearchBox"
                  id="fleetSearchBox"
                  placeholder="Search using fleet name or fleet Id"
                  value={fleetSearchBox.value}
                  onChange={(e) => this.handleSearchChange(e)}
                />
                <InputGroupAddon addonType="append" >
                  <div className="input-group-text" style={{ zIndex: 'auto !important', cursor: 'pointer' }}>
                    <FontAwesomeIcon htmlFor="datepicker" icon={faSearch} />
                  </div>
                </InputGroupAddon>

              </InputGroup>

            </Col>
            <Col>
              <FleetTypeFilter
                fleetDetailFilter={fleetDetailFilterData}
                applyFilter={this.applyFilter} />
            </Col>

            {total_fleets > 0 && userDetail && userDetail.permissions && userDetail.permissions.includes(Permissions.DOWNLOAD_FLEET_MASTER) &&
              <Col className="d-flex" style={{ justifyContent: 'flex-end', margin: 'auto' }}>
                <img src="images/download.svg" alt='download' className="download-report-icon margin-left-10" onClick={this.downloadExcelFleet} /* onClick={this.downloadExcel} */ />&nbsp;&nbsp;
                <span className="Download-Full-Report pull-right mr-2" onClick={this.downloadExcelFleet} /* onClick={this.downloadExcel} */ style={{ cursor: 'pointer' }}>Download Fleet Details</span>
              </Col>
            }
          </Row>
          <br />

          <Row>
            <Col>
              <Card>
                <CardBody className="p-2 pt-2">
                  <table className="table table-bordered table-responsive">
                    <thead style={{ background: '#f6f6f6' }} className="fleet-detail-tbl-thead">
                      <tr>
                        {/* hide changes 8aug23 */}
                        <th style={{ fontSize: '12px' }} className="text-align-center">Region<br />(FM Area)</th>
                        <th style={{ fontSize: '12px' }} className="text-align-center">Fleet Name</th>
                        <th style={{ fontSize: '12px' }} className="text-align-center">Club Name</th>
                        <th style={{ fontSize: '12px' }} className="text-align-center">Membership Type</th>
                        {/* <th style={{ fontSize: '12px' }} className="text-align-center">Fleet Type</th> */}
                        <th style={{ fontSize: '12px' }} className="text-align-center">Fleet Status</th>
                        <th style={{ fontSize: '12px' }} className="text-align-center">Total Vehicles</th>
                        {/* <th className="text-align-center" style={{ minWidth: '80px', fontSize: '12px' }}>TBB<br />Potential<br />(Avg /<br />Month)</th>
                        <th className="text-align-center" style={{ minWidth: '80px', fontSize: '12px' }}>TBR<br />Potential<br />(Avg /<br />Month)</th>
 <th className="text-align-center" style={{ minWidth: '80px', fontSize: '12px' }}>Retread<br />Potential<br />(Avg /<br />Month)</th> */}
                        {/* {headers && headers.sales_header ?
                          <th className="text-align-center" style={{ fontSize: '12px' }}>
                            <div className="d-flex">
                              {headers.sales_header}
                              <MappleToolTip float={true} direction={'left'} showMappleIf={'true'}
                                backgroundColor="#ffffff">
                                <div style={{ marginLeft: '5px' }}>

                                  <img
                                    src="images/about-545a60.svg"
                                    id="editorimage"
                                    style={{ cursor: 'pointer' }}
                                    onClick={this.Show_entermsgcontent}
                                  />
                                </div>
                                <div className="text-align-left">
                                  <span className="fleet-detail-tooltip-value d-flex-column">
                                    <span style={{ marginTop: '5px' }}>
                                      The verified offtake sales of last 3 months without considering current month.
                                      <br />
                                      <br />
                                      e.g. If today is 5th August it includes data from May 1st until 31st July.

                                    </span>
                                  </span>
                                </div>
                              </MappleToolTip>
                            </div></th>
                          : ''} */}

                        {/* {headers && headers.sales_header_prev_year ?
                          <th className="text-align-center" style={{ fontSize: '12px' }}>
                            <div className="d-flex">
                              {headers.sales_header_prev_year}
                              <MappleToolTip float={true} direction={'left'} showMappleIf={'true'}
                                backgroundColor="#ffffff">
                                <div style={{ marginLeft: '5px' }}>
                                  <img
                                    src="images/about-545a60.svg"
                                    id="editorimage"
                                    style={{ cursor: 'pointer' }}
                                    onClick={this.Show_entermsgcontent}
                                  />
                                </div>
                                <div className="text-align-left">
                                  <span className="fleet-detail-tooltip-value d-flex-column">
                                    <span style={{ marginTop: '5px' }}>
                                      The verified offtake sales of last financial year 3 months based on current month.
                                      <br />
                                      <br />
                                      e.g. If today is 5th August, 2020 it includes data from May 1st until 31st July of 2019.
                                    </span>
                                  </span>
                                </div>
                              </MappleToolTip>
                            </div></th>
                          : ""} */}
                        {/* {headers && headers.ytd_header ?
                          <th className="text-align-center" style={{ fontSize: '12px' }}>
                            <div className="d-flex">
                              <span>
                                {headers.ytd_header}
                              </span>
                              <MappleToolTip float={true} direction={'left'} showMappleIf={'true'}
                                backgroundColor="#ffffff">
                                <div style={{ marginLeft: '5px' }}>
                                  <img
                                    src="images/about-545a60.svg"
                                    id="editorimage"
                                    style={{ cursor: 'pointer' }}
                                    onClick={this.Show_entermsgcontent}
                                  />
                                </div>
                                <div className="text-align-left">
                                  <span className="fleet-detail-tooltip-value d-flex-column">
                                    <span style={{ marginTop: '5px' }}>
                                      The verified offtake sales of this FY without considering current month.
                                      <br />
                                      <br />
                                      e.g. If today is 5th August,2020 it includes data from April 1st 2020 until 31st July 2020.
                                    </span>
                                  </span>
                                </div>
                              </MappleToolTip>
                            </div>
                          </th> : ""} */}
                        {/* {headers && headers.ytd_header_prev_year ?
                          <th className="text-align-center" style={{ fontSize: '12px' }}>
                            <div className="d-flex">
                              <span>
                                {headers.ytd_header_prev_year}
                              </span>
                              <MappleToolTip float={true} direction={'left'} showMappleIf={'true'}
                                backgroundColor="#ffffff">
                                <div style={{ marginLeft: '5px' }}>
                                  <img
                                    src="images/about-545a60.svg"
                                    id="editorimage"
                                    style={{ cursor: 'pointer' }}
                                    onClick={this.Show_entermsgcontent}
                                  />
                                </div>
                                <div className="text-align-left">
                                  <span className="fleet-detail-tooltip-value d-flex-column">
                                    <span style={{ marginTop: '5px' }}>
                                      The verified offtake sales of previous FY similar to YTD Sales.
                                      <br />
                                      <br />
                                      e.g. If today is 5th August,2020 it includes data from April 1st 2019 until 31st July 2019.

                                    </span>
                                  </span>
                                </div>
                              </MappleToolTip>
                            </div>
                          </th>
                          : ""} */}
                        {/* <th className="text-align-center" style={{ fontSize: '12px' }}>
                          <div className="d-flex">
                            <span>Share of Business %</span>
                            <MappleToolTip float={true} direction={'left'} showMappleIf={'true'}
                              backgroundColor="#ffffff">
                              <div style={{ marginLeft: '5px' }}>
                                <img
                                  src="images/about-545a60.svg"
                                  id="editorimage"
                                  alt='about-545a60'
                                  style={{ cursor: 'pointer' }}
                                  onClick={this.Show_entermsgcontent}
                                />
                              </div>
                              <div className="text-align-left">
                                <span className="fleet-detail-tooltip-value d-flex-column">
                                  <span style={{ marginTop: '5px' }}>
                                    <b>Shares of Business % is calculated as</b>
                                    <br />
                                    [Last 3 Months of Total Sales of Fleet] * 100 / [Total 3 Months Potential Of Fleet]
                                    <br /><br />
                                    Here Last 3 months does not include sales for current month.
                                  </span>
                                </span>
                              </div>
                            </MappleToolTip>
                          </div></th> */}
                      </tr>
                    </thead>

                    <tbody>
                      {
                        (fleet_detail_list || []).map((detail) => (
                          <tr>
                            <td className="text-align-center fleet-detail-table-td">{detail.region} ({detail.fm_area})</td>
                            <td className="text-capitalize text-align-center">

                              <span className="fleet-detail-business-name-td">{detail.owner_name}</span><br />
                              <span
                                className="fleet-detail-table-td Download-Full-Report"
                                onClick={() => this.fleetNameClick(detail.id)}
                                style={{ cursor: 'pointer', fontSize: '12px', textTransform: 'none', color: '#545cd8', textDecoration: "underline" }}>{detail.member_id}</span>
                            </td>
                            <td className="text-align-center fleet-detail-table-td">{detail.club || "-"}</td>
                            <td className="text-align-center fleet-detail-table-td">{detail.member_type}</td>
                            {/* <td className="text-align-center fleet-detail-table-td">{detail.fleet_type}</td> */}
                            <td className="text-align-center fleet-detail-table-td">{detail.fleet_status}</td>
                            <td className="text-align-center fleet-detail-table-td">{detail.total_vehicles}</td>
                            {/* <td className="text-align-center fleet-detail-table-td">{detail.potential_tbb}</td>
                            <td className="text-align-center fleet-detail-table-td">{detail.potential_tbr}</td>
                            <td className="text-align-center fleet-detail-table-td">{detail.retread_potential}</td> */}
                            {/* <td className="text-align-center fleet-detail-table-td">{detail.sales}</td>
                            <td className="text-align-center fleet-detail-table-td">{detail.previous_sales}</td>
                            <td className="text-align-center fleet-detail-table-td">{detail.ytd}</td>
                            <td className="text-align-center fleet-detail-table-td">{detail.previous_ytd}</td> */}

                            {/* <td className="text-align-center fleet-detail-table-td">{detail.business_share}</td> */}
                          </tr>
                        ))
                      }
                    </tbody>
                  </table>
                  {total_fleets <= 0 &&
                    <div className="no-data" style={{ marginTop: '-17px' }}>
                      Currently, there is no fleets to display
                    </div>
                  }
                  {total_fleets > 10 && <div className="pull-right" style={{ display: 'flex', marginTop: '10px' }}>
                    <span style={{ marginTop: '7px' }}>
                      <span className="showing">Showing </span>
                      <span className="showing-page">
                        {`${this.state.page - 1}1`}
                        -{(((this.state.page - 1) * 10) + (fleet_detail_list || []).length) < 10 ? '0' : ''}{(((this.state.page - 1) * 10) + (fleet_detail_list || []).length)}
                        &nbsp;of {this.state.pageCount < 10 ? '0' : ''}{this.state.pageCount}
                      </span>
                    </span>
                    &nbsp;&nbsp;&nbsp;
                    <ReactPaginate
                      previousLabel={<FontAwesomeIcon icon={faChevronLeft} />}
                      nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
                      breakLabel="..."
                      breakClassName="break-me"
                      pageCount={this.state.pageCount}
                      forcePage={this.state.page - 1}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={this.handlePageClick}
                      containerClassName="pagination"
                      subContainerClassName="pages pagination"
                      pageLinkClassName="c-page"
                      previousLinkClassName="c-prev"
                      nextLinkClassName="c-next"
                      breakLinkClassName="c-break-line"
                      activeClassName="active"
                      activeLinkClassName="c-page-link"
                    />
                  </div>
                  }

                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div >
    );
  }
}

export default ListOfFleets;
